import { render, staticRenderFns } from "./CustomAttributeValueComponent.vue?vue&type=template&id=2009ed46&"
import script from "./CustomAttributeValueComponent.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeValueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports